import React, { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Col, Row } from "reactstrap";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { Chips } from "primereact/chips";
import { InputText } from "primereact/inputtext";
import { Editor } from "primereact/editor";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import axios from "axios";
import { triggerAlert } from "utils/CommonFunctions";
import { Message } from "primereact/message";
import { CascadeSelect } from "primereact/cascadeselect";
import { ChevronDownIcon } from "primereact/icons/chevrondown";
import { ChevronRightIcon } from "primereact/icons/chevronright";

const SubmitContacttoCandidate = ({ selectedCustomers }) => {
  const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
  const [selectedJobTitles, setSelectedJobTitles] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [jobDescriptions, setJobDescriptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedSignature, setSelectedSignature] = useState(null);
  const [jobsallpopup, SetJobsallPopup] = useState(false);
  const [linkContactsVisible, setLinkContactsVisible] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [contactDescriptions, setContactDescriptions] = useState([]);
  const [linkContactsVisible1, setLinkContactsVisible1] = useState(false);
  const [selectedContacts1, setSelectedContacts1] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [candtextEditor, setCandtextEditor] = useState("");
  const [subject, setSubject] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const fileListRef = useRef(null);
  const fileUploadRef = useRef(null);
  const [errors, setErrors] = useState({ to: '', subject: '' });
  const [isPrivate, setIsPrivate] = useState(false);
  const [searchTextTo, setSearchTextTo] = useState("");
  const [searchTextCc, setSearchTextCc] = useState("");
  const [selectedFromEmail, setSelectedFromEmail] = useState(null);
  const [fromEmail, setFromEmail] = useState([]);
  const [templatei, setTemplatei] = useState([]);
  const [signatutei, setSignatutei] = useState([]);
  const [uniqueUserId, setUniqueUserId] = useState("");
  const [warningDialogVisible, setWarningDialogVisible] = useState(false);
  const [typeInterviewcontact, setTypeInterviewcontact] = useState([]);
  const [showNoSubjectConfirm, setShowNoSubjectConfirm] = useState(false);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [candidates, setCandidates] = useState([]);
  const [records, setRecords] = useState(0);
  const [lazyParamsCand, setLazyParamsCand] = useState({
    first: 0,
    rows: 10,
    page: 0,
  });
  const [templateBody, setTemplateBody] = useState("");
  const [signatureText, setSignatureText] = useState("");
  const [emailtextEditor, setEmailtextEditor] = useState('');
  const [defaultSignature, setDefaultSignature] = useState("");
   const [isLoading, setIsLoading] = useState(false);

  const handleSubmitContact = async () => {
  if (selectedCustomers.length === 0) {
    setWarningDialogVisible(true);
    return;
  }

  if (!typeInterviewcontact.length) {
    await getAllActiveContacts(1, lazyParams.rows);
  }

  const selectedEmails = selectedCustomers.map(customer => customer.email).filter(email => email);
  setJobDescriptions(selectedEmails);

  // Sync selectedContacts with selectedCustomers
  const matchedContacts = typeInterviewcontact.filter(contact =>
    contact && contact.email && selectedEmails.includes(contact.email)
  );
  setSelectedContacts(matchedContacts);

  // Reset template and signature states
  setSelectedTemplate(null);
  setTemplateBody("");
  setSelectedSignature(signatutei.find(signature => signature.is_default) || null);
  setSignatureText(defaultSignature || "");
  setCandtextEditor("");
  setEmailtextEditor("");

  setJobDetailsVisible(true);
};
  const footerContent = (
    <div>
      <div className="d-flex align-items-center">
        <Checkbox inputId="checkbox" checked={isPrivate} onChange={(e) => setIsPrivate(e.checked)} />
        <label htmlFor="username" className="ms-2 mt-1">
          Private
        </label>
      </div>
    </div>
  );

 const stripSignature = (emailBody) => {
  if (!emailBody) return "";

  // Remove everything after the last closing </table> tag
  const lastTableIndex = emailBody.lastIndexOf("</table>");
  if (lastTableIndex !== -1) {
    return emailBody.substring(0, lastTableIndex + 8).trim(); // include </table>
  }
  return emailBody; // fallback
};

  const formatJobsToHTMLTable = (filteredJobs) => {
  if (filteredJobs.length === 0) return "";
  const defaultText = `Dear {{contact_name}}, <br> <br>`;
  const tableStyle = "width:100%;border-collapse:collapse;border:1px solid #333;font-family:Arial,sans-serif;font-size:14px;";
  const thStyle = "background:#f5f5f5;border:1px solid #333;padding:8px;text-align:left;";
  const tdStyle = "border:1px solid #333;padding:8px;";

  const formattedJobDetails = filteredJobs
    .map(
      (job) => `
      <table style="${tableStyle}">
        <tr>
          <td style="${tdStyle} width:25%;"><b> Candidate </b></td>
          <td style="${tdStyle} width:75%;">${job.first_name} ${job.middle_name || ''} ${job.last_name || ''}${job.designation ? ' - ' + job.designation : ''}</td>
        </tr>
        <tr>
          <td style="${thStyle} width:25%;"><b>Primary Skills</b></td>
          <td style="${tdStyle} width:75%;">${job.primary_skill_names || ''}</td>
        </tr>
        <tr>
          <td style="${thStyle} width:25%;"><b>Contact Details</b></td>
          <td style="${tdStyle} width:75%;"><b>Phone number:</b> ${job.mobile_phone || ''} <b>Email:</b> ${job.email || ''}</td>
        </tr>
        <tr>
          <td style="${tdStyle} width:25%;"><b>Work Experience</b></td>
          <td style="${tdStyle} width:75%;">${job.total_experience || ''} Yrs</td>
        </tr>
        <tr>
          <td style="${tdStyle} width:25%;"><b>Details</b></td>
          <td style="${tdStyle} width:75%;"><b>Salary Expectation:</b> \₹ ${job.expected_salary || ''}, <b>Availability:</b> ${job.availability_date || ''}, <b>Employment Type:</b> ${job.employee_type || ''}</td>
        </tr>
      </table>
      <br>
    `
    )
    .join("");
  return `${defaultText}<br><br>${formattedJobDetails}`;
};

 const handleSave = () => {
   const candidatesTableHTML = formatJobsToHTMLTable(selectedJobs);
   setCandtextEditor(candidatesTableHTML);
   const signature = selectedSignature?.id ? signatureText : defaultSignature;
   setEmailtextEditor(`${candidatesTableHTML}${templateBody ? `<br>${templateBody}` : ''}${signature ? `<br>${signature}` : ''}`);
   setJobDetailsVisible(false);

   const validResumes = selectedJobs
     .filter(candidate => candidate.resume)
     .map(candidate => ({ name: `${candidate.first_name}_${candidate.last_name}_resume.pdf`, data: candidate.resume }));
   setUploadedFiles(validResumes);

   SetJobsallPopup(true);
 };

  const handleRefresh = () => {
    setSelectedJobs([]);
    setSearchText("");
  };

  const handleSaveContact = () => {
    const contactDetails = selectedContacts
      .filter(contact => contact && contact.email)
      .map(contact => contact.email);
    setJobDescriptions(prev => [...new Set([...prev, ...contactDetails])]);
    setLinkContactsVisible(false);
  };

  const handleRefresh1 = () => {
    setSelectedContacts([]);
    setSearchTextTo("");
  };

  const handleSaveContact1 = () => {
    const contactDetails = selectedContacts1
      .filter(contact => contact && contact.email)
      .map(contact => contact.email);
    setContactDescriptions(prev => [...new Set([...prev, ...contactDetails])]);
    setLinkContactsVisible1(false);
  };

  const handleRefresh2 = () => {
    setSelectedContacts1([]);
    setSearchTextCc("");
  };

 const onUploadHandler1 = async (e) => {
  const files = e.files;
  const newFiles = await Promise.all(
    files.map(
      (file) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64Data = reader.result.split(",")[1];
            resolve({ name: file.name, data: base64Data });
          };
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(file);
        })
    )
  ).then((results) => results.filter((file) => file !== null));

  setUploadedFiles((prevFiles) => {
    const uniqueNewFiles = newFiles.filter(
      (newFile) => !prevFiles.some((file) => file.name === newFile.name)
    );
    return [...prevFiles, ...uniqueNewFiles];
  });

  // Clear the FileUpload component to allow new selections
  if (fileUploadRef.current) {
    fileUploadRef.current.clear();
    fileUploadRef.current.setFiles([]); // Ensure internal file list is cleared
  }
};

  const fetchCandidates = async (page = 1, size = 10) => {
    try {
      const response = await axios.get(`/api/v1/candidates/?page=${page}&size=${size}&status=Active`);
      setCandidates(response.data.results);
      setRecords(response.data.count);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchCandidates(1, lazyParamsCand.rows);
  }, []);

  const onPageChange = (event) => {
    setLazyParamsCand({
      ...lazyParamsCand,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
    fetchCandidates(event.first / event.rows + 1, event.rows);
  };

  const handleCancel = () => {
  setErrors({ to: '', subject: '', from: '' });
  setSelectedJobs([]);
  setJobDescriptions([]);
  setContactDescriptions([]);
  setSelectedContacts([]);
  setSelectedContacts1([]);
  setJobDetailsVisible(false);
  SetJobsallPopup(false);
  setSubject("");
  setUploadedFiles([]);
  setSearchText("");
  // setSelectedFromEmail(null);
  setIsPrivate(false);
  setSelectedTemplate(null);
  setTemplateBody("");
  setSelectedSignature(null);
  setSignatureText("");
  setCandtextEditor("");
  setEmailtextEditor("");
  if (fileUploadRef.current) {
    fileUploadRef.current.clear();
    fileUploadRef.current.setFiles([]);
  }
};

  const searchCandidates = (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }
    const fullName = (rowData) => {
      const first = rowData.first_name || "";
      const middle = rowData.middle_name || "";
      const last = rowData.last_name || "";
      return [first, middle, last].filter(Boolean).join(" ").trim();
    };
    const filteredCandidates = candidates.filter(candidate =>
      fullName(candidate).toLowerCase().includes(query.toLowerCase()) ||
      candidate.job_title?.toLowerCase().includes(query.toLowerCase()) ||
      candidate.current_company?.toLowerCase().includes(query.toLowerCase())
    );
    setSearchResults(filteredCandidates);
  };

  const getFallbackSignature = () => {
  return `
    
  `;
};

 const handleSend = async () => {
  let isValid = true;
  const newErrors = { to: '', subject: '', from: '' };
  if (jobDescriptions.length === 0) {
    newErrors.to = 'Recipient email is required.';
    isValid = false;
  }
  if (!selectedFromEmail) {
    newErrors.from = 'From email is required.';
    isValid = false;
  }
  // if (!subject.trim()) {
  //   newErrors.subject = 'Subject is required.';
  //   isValid = false;
  // }
  setErrors(newErrors);
  if (!isValid) {
    return;
  }
  if (!subject.trim()) {
      setShowNoSubjectConfirm(true);
      return;
    }
    await sendMail();
};

  const sendMail = async () => {
    setIsLoading(true);
    const payload = {
      contact_id: String(selectedCustomers[0]?.id || ""),
      candidate: selectedJobs.map(job => ({
        candidate: String(job.candidate_id),
        first_name: job.first_name,
        middle_name: job.middle_name || "",
        last_name: job.last_name,
        designation: job.designation,
        current_company: job.current_company,
        candidate_email: job.email
      })),
      status: String(selectedCustomers.status),
      notes: "",
      user_ids: String(uniqueUserId),
      applied_date: new Date().toISOString(),
      stage: "",
      from_address: selectedFromEmail,
      to_addresses: jobDescriptions,
      cc_addresses: contactDescriptions,
      subject: subject,
      body: emailtextEditor,
      attachments: uploadedFiles.map(file => ({
        file_name: file.name,
        file_data: file.data
      })),
      private: isPrivate
    };
    try {
      const response = await axios.post(`/api/v1/submit-candidate-contact/`, payload);
      if (response.status === 201) {
        handleCancel();
        triggerAlert('success', 'Success', 'Successfully created');
          // Show grouped warning toast for skipped candidates
          if (response.data.skipped && Array.isArray(response.data.skipped) && response.data.skipped.length > 0) {
            const skippedNames = [...new Set(response.data.skipped.map(c => c.candidate_name))].join(", ");
            triggerAlert('warning', 'Skipped Candidates', `${skippedNames} skipped`);
          }
      }
    } catch (error) {
      console.error('Error:', error);
      handleCancel();
      triggerAlert('warning', 'Warning', error.response?.data?.error || 'An error occurred while sending data');
    } finally {
      setIsLoading(false);
    }
  };

    const handleConfirmSend = async () => {
    setShowNoSubjectConfirm(false);
    await sendMail();
  };
  const handleCancelSend = () => {
    setShowNoSubjectConfirm(false);
  };

  const handleSearchTo = (e) => {
    setSearchTextTo(e.target.value);
  };

  const handleSearchCc = (e) => {
    setSearchTextCc(e.target.value);
  };

  const fetchDefaultSignature = async () => {
    try {
      const response = await axios.get(`/api/v1/email-signatures/default/`);
      if (response.data && Array.isArray(response.data) && response.data.length > 0 && response.data[0].signature_text) {
        setDefaultSignature(response.data[0].signature_text || "");
      }
      else {
      setDefaultSignature(getFallbackSignature()); // Use fallback signature if API returns no default
    }
    } catch (error) {
      console.error("Error fetching default signature:", error);
      setDefaultSignature(getFallbackSignature());
    }
  };

  useEffect(() => {
    fetchDefaultSignature();
  }, []);

  useEffect(() => {
    if (defaultSignature) {
      setEmailtextEditor(`
        Dear {{contact_name}}, <br> <br>
        <br>
        <table border="1" cellpadding="5" cellspacing="0" style="width: 100%; border-collapse: collapse;">
          <tr>
            <th> </th>
            <td><b> {{Candidate_name}} </b></td>
            <td></td>
          </tr>
          <tr>
            <th> </th>
            <td><b> Primary Skills </b></td>
            <td></td>
          </tr>
          <tr>
            <th style="text-align: left;"></th>
            <td><b> Contact Details </b></td>
            <td><b>Phone number:</b> </td>
          </tr>
          <tr>
            <th style="text-align: left;"> </th>
            <td><b> Work Experience </b></td>
            <td></td>
          </tr>
          <tr>
            <th style="text-align: left;"></th>
            <td><b> Details </b> </td>
            <td><b>Salary Expectation:  </b> , <b>Availability:</b> , <b>Employment Type:  </b>  </td>
          </tr>
        </table>
        <br>
        ${defaultSignature}
      `);
    }
  }, [defaultSignature]);

  const stripTemplate = (emailBody) => {
  if (!emailBody) return { candidatePart: '', signaturePart: '' };
  const lastTableIndex = emailBody.lastIndexOf("</table>");
  if (lastTableIndex === -1) return { candidatePart: '', signaturePart: '' };
  const candidatePart = emailBody.substring(0, lastTableIndex + 8).trim();
  const afterTable = emailBody.substring(lastTableIndex + 8);
  const signatureMarkers = [/<br\s*\/?>\s*Best Regards,/i, /<br\s*\/?>\s*$/i];
  let signatureStartIndex = -1;
  for (const marker of signatureMarkers) {
    signatureStartIndex = afterTable.search(marker);
    if (signatureStartIndex !== -1) break;
  }
  const signaturePart = signatureStartIndex !== -1 ? afterTable.substring(signatureStartIndex).trim() : '';
  return { candidatePart, signaturePart };
};

 const handleTemplateChange = async (e) => {
  try {
    const templateId = e.value?.id;
    setSelectedTemplate(e.value);
    if (!templateId) {
      setTemplateBody("");
      const { candidatePart, signaturePart } = stripTemplate(emailtextEditor);
      setEmailtextEditor(`${candidatePart}${signaturePart ? `<br>${signaturePart}` : ''}`);
      return;
    }
    const response = await axios.get(`/api/v1/email-templates/${templateId}/`);
    if (response?.data) {
      const { body } = response.data;
      setTemplateBody(body || "");
      const { candidatePart, signaturePart } = stripTemplate(emailtextEditor);
      const signature = selectedSignature?.id ? signatureText : defaultSignature;
      setEmailtextEditor(`${candidatePart}${body ? `<br>${body}` : ''}${signature ? `<br>${signature}` : ''}`);
    }
  } catch (error) {
    console.error("Error fetching template:", error);
    setTemplateBody("");
    const { candidatePart, signaturePart } = stripTemplate(emailtextEditor);
    setEmailtextEditor(`${candidatePart}${signaturePart ? `<br>${signaturePart}` : ''}`);
  }
};

const handleSignatureChange = async (e) => {
  try {
    const signatureId = e.value?.id;
    setSelectedSignature(e.value);
    if (!signatureId) {
      setSignatureText("");
      const { candidatePart } = stripTemplate(emailtextEditor);
      setEmailtextEditor(`${candidatePart}${templateBody ? `<br>${templateBody}` : ''}`);
      return;
    }
    const response = await axios.get(`/api/v1/email-signatures/${signatureId}/`);
    if (response?.data) {
      const { signature_text } = response.data;
      setSignatureText(signature_text || "");
      const { candidatePart } = stripTemplate(emailtextEditor);
      setEmailtextEditor(`${candidatePart}${templateBody ? `<br>${templateBody}` : ''}${signature_text ? `<br>${signature_text}` : ''}`);
    }
  } catch (error) {
    console.error("Error fetching signature:", error);
    setSignatureText("");
    const { candidatePart } = stripTemplate(emailtextEditor);
    setEmailtextEditor(`${candidatePart}${templateBody ? `<br>${templateBody}` : ''}`);
  }
};

useEffect(() => {
  if (defaultSignature && !candtextEditor) {
    setSignatureText(defaultSignature);
    setEmailtextEditor(`Dear {{contact_name}}, <br> Please find below candidate with resume<br><br>${defaultSignature}`);
  }
}, [defaultSignature, candtextEditor]);

  
  const templateOptions = templatei;
  const signatureOptions = signatutei;

  const getFormData = async () => {
    try {
      const response = await axios.get(`/api/v1/smtp-accounts/`);
      const transformedData = response.data.results.map((item) => ({
        email: item.from_email,
        id: item.smtp_id,
      }));
      setFromEmail(transformedData);
    } catch (error) {
      console.error("Error fetching SMTP accounts:", error);
    }
  };

  const getTemplateItems = async () => {
    try {
      const response = await axios.get(`/api/v1/email-templates/`);
      const transformedData = response.data.map((city) => ({
        name: city.name,
        id: city.template_id,
        body: city.body,
      }));
      setTemplatei(transformedData);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const getSignatureItems = async () => {
    try {
      const response = await axios.get(`/api/v1/email-signatures/`);
      const transformedData = response.data.map((city) => ({
        name: city.name,
        id: city.signature_id,
        is_default: city.is_default || false,
      }));
      // Sort the signatures so that the default one appears first
        transformedData.sort((a, b) => b.is_default - a.is_default);

      setSignatutei(transformedData);
    } catch (error) {
      console.error("Error fetching signatures:", error);
    }
  };

  useEffect(() => {
    if (signatureOptions.length > 0) {
        const defaultSignature = signatureOptions.find(signature => signature.is_default);
        if (defaultSignature) {
            setSelectedSignature(defaultSignature);
        }
    }
}, [signatureOptions]); 


  const getAllActiveContacts = async (page = 1, perPage = 10) => {
    try {
      const response = await axios.get(`/api/v1/contacts/?page=${page}&size=${perPage}&status=Active`);
      setTypeInterviewcontact(response.data.results);
      setTotalRecords(response.data.count);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  const onPageChange1 = (event) => {
    setLazyParams({
      ...lazyParams,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
    getAllActiveContacts(event.first / event.rows + 1, event.rows);
  };

  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"));
    if (userInfo && userInfo.user_details) {
      setUniqueUserId(userInfo.user_details.unique_user_id);
      console.log("Unique User ID:", userInfo.user_details.unique_user_id);
    }
  }, []);

  useEffect(() => {
    getFormData();
    getTemplateItems();
    getSignatureItems();
    getAllActiveContacts(1, lazyParams.rows);
    getAllSmPtvaluesprimary()
  }, []);

  const filteredContacts = (contacts, searchText) => {
    if (!Array.isArray(contacts)) {
        return [];
    }
    const search = (searchText ?? "").toString().toLowerCase();
    return contacts.filter(contact => {
        if (!contact || typeof contact !== "object") {
            return false;
        }
        const fullName = `${contact.first_name ?? ""} ${contact.middle_name ?? ""} ${contact.last_name ?? ""}`.toLowerCase();
        return (
            fullName.includes(search) ||
            (contact.job_title ?? "").toString().toLowerCase().includes(search) ||
            (contact.email ?? "").toString().toLowerCase().includes(search)
        );
    });
};


const getAllSmPtvaluesprimary = async () => {
  try {
    // Fetch ALL SMTP accounts first
    const response = await axios.get(`/api/v1/smtp-accounts/`);
    const allData = response.data.results.map((item) => ({
      email: item.from_email,
      id: item.smtp_id,
      is_primary: item.is_primary,
    }));

    setFromEmail(allData); // ✅ Set ALL emails in dropdown

    // Find primary email
    const primary = allData.find((item) => item.is_primary);
    if (primary) {
      setSelectedFromEmail(primary.email); // ✅ Preselect primary
    } else {
      console.warn("No primary email found, selecting first email");
      if (allData.length > 0) {
        setSelectedFromEmail(allData[0].email); // fallback
      }
    }
  } catch (error) {
    console.error("Error fetching SMTP accounts:", error);
  }
};


  return (
    <React.Fragment>
      <button
        type="button"
        className="btn btn-secondary import-res-btn ms-1 me-1"
        onClick={()=> {handleSubmitContact();}}
      >
        Send Job to Candidate
      </button>
      <Dialog
        header="Warning"
        visible={warningDialogVisible}
        modal
        onHide={() => setWarningDialogVisible(false)}
        style={{ width: "30vw" }}
        className="modal-content"
      >
        <div className="p-3 text-center">
          <p>Please select at least one contact to proceed.</p>
          <div className="d-flex justify-content-center mt-4">
            <Button
              type="button"
              label="OK"
              className="btn btn-primary btn-main"
              onClick={() => setWarningDialogVisible(false)}
            />
          </div>
        </div>
      </Dialog>
      <Dialog
        header="Submit Contact to Candidate"
        visible={jobsallpopup}
        className="interview-popup"
        onHide={handleCancel}
        style={{ width: "75vw", height: "82%" }}
        maximizable
        modal
        footer={footerContent}
      >
        <Row>
          <div className="popup-header-bg">
            <Col lg={12} className="d-flex align-items-center">
              <Dropdown
                value={selectedTemplate}
                onChange={handleTemplateChange}
                options={templateOptions}
                placeholder="Template"
                optionLabel="name"
                className="w-full md:w-10rem action-items me-1"
                dropdownIcon={opts => {
                  return opts.iconProps["data-pr-overlay-visible"] ? (
                    <ChevronRightIcon {...opts.iconProps} />
                  ) : (
                    <ChevronDownIcon {...opts.iconProps} />
                  );
                }}
              />
              <Dropdown
                value={selectedSignature}
                onChange={handleSignatureChange}
                options={signatureOptions}
                optionLabel="name"
                placeholder="Signature"
                className="w-full md:w-10rem action-items me-1"
                dropdownIcon={opts => {
                  return opts.iconProps["data-pr-overlay-visible"] ? (
                    <ChevronRightIcon {...opts.iconProps} />
                  ) : (
                    <ChevronDownIcon {...opts.iconProps} />
                  );
                }}
              />
              <div className="d-inline-block">
                <FileUpload
  ref={fileUploadRef}
  name="emailAttachments[]"
  url={'/api/upload'}
  mode="basic"
  multiple
  accept="image/*,application/pdf"
  maxFileSize={5000000}
  auto
  chooseLabel={<span>Attach File</span>}
  customUpload
  uploadHandler={onUploadHandler1}
  className="me-2"
/>
              </div>
              <Button className="preview-btn ms-auto" onClick={handleSend} disabled={isLoading}>
                <i className="pi pi-send me-1"></i> {isLoading ? 'Sending...' : 'Send'}
              </Button>
            </Col>
          </div>
        </Row>
        <div className="bg-form form-insidepop">
          <Row className="mb-2">
            <Col xl={12}>
              <Row className="mb-2">
                <Col xl={1} className="pe-0">
                  <div className="label-input">
                    <Dropdown
                      value={selectedFromEmail}
                      options={fromEmail}
                      onChange={(e) => {
                        setSelectedFromEmail(e.value.email);
                      }}
                      optionLabel="email"
                      placeholder="From"
                      className="from-width w-full"
                    />
                  </div>
                </Col>
                <Col xl={11}>
                  <Chips
                    value={selectedFromEmail ? [selectedFromEmail] : []}
                    onChange={(e) => {
                      if (e.value.length > 0) {
                        setSelectedFromEmail(e.value[0]);
                      } else {
                        setSelectedFromEmail(null);
                      }
                    }}
                    className="size-mail w-full"
                    max={1}
                  />
                  {errors.from && <Message severity="error" text={errors.from} className="mt-2"/>}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xl={1} className="pe-0">
                  <div className="label-input">
                    <Dropdown
                      placeholder="To"
                      className="from-width w-full"
                      onClick={(e) => {
                        e.preventDefault();
                        setLinkContactsVisible(true);
                      }}
                      showClear={false}
                      showOnFocus={false}
                    />
                  </div>
                </Col>
                <Col xl={11}>
                  <Chips
                    value={jobDescriptions}
                    onChange={(e) => setJobDescriptions(e.value)}
                    className="size-mail w-full"
                  />
                  {errors.to && <Message severity="error" text={errors.to} className="mt-2"/>}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xl={1} className="pe-0">
                  <div className="label-input">
                    <Dropdown
                      placeholder="Cc"
                      className="from-width w-full"
                      onClick={(e) => {
                        e.preventDefault();
                        setLinkContactsVisible1(true);
                      }}
                      showClear={false}
                      showOnFocus={false}
                    />
                  </div>
                </Col>
                <Col xl={11}>
                  <Chips
                    value={contactDescriptions}
                    onChange={(e) => setContactDescriptions(e.value)}
                    className="size-mail w-full"
                  />
                </Col>
              </Row>
              <Row className="size-mail mb-1">
                <Col xl={1}>
                  <label htmlFor="interview">Subject:</label>
                </Col>
                <Col xl={11}>
                  <InputText
                    id="interview"
                    aria-describedby="username-help"
                    placeholder=""
                    className="w-full"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                  {errors.subject && <Message severity="error" text={errors.subject} className="mt-2" />}
                </Col>
              </Row>
              {uploadedFiles.length > 0 && (
  <Row className="size-mail mt-2 align-items-baseline">
    <Col xl={1}>
      <label>Attached:</label>
    </Col>
    <Col xl={11}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          ref={fileListRef}
          style={{
            display: "flex",
            overflowX: "auto",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            padding: "10px 0px",
            borderRadius: "4px",
          }}
        >
          {uploadedFiles.map((file, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                marginRight: "15px",
                padding: "5px 10px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                background: "#f9f9f9",
                boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
              }}
            >
              <div>
                <i
                  className="pi pi-file"
                  style={{ marginRight: "5px" }}
                ></i>
                <span>{file.name}</span>
                <i
                  className="pi pi-times-circle"
                  style={{
                    color: "red",
                    marginLeft: "8px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setUploadedFiles((prevFiles) =>
                      prevFiles.filter((_, i) => i !== index)
                    );
                    if (fileUploadRef.current) {
                      fileUploadRef.current.clear();
                      fileUploadRef.current.setFiles([]); // Reset internal file list
                    }
                  }}
                ></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Col>
  </Row>
)}
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Editor
                value={emailtextEditor}
                onTextChange={(e) => setEmailtextEditor(e.htmlValue)}
                className="jobsall-editor"
              />
            </Col>
          </Row>
        </div>
      </Dialog>
      <Dialog
        header="Select Candidates"
        visible={jobDetailsVisible}
        onHide={handleCancel}
        style={{ width: "40vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        className="cand-details"
      >
        <Row>
          <Col lg={12}>
            <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
              <InputText
                placeholder="Search with designation"
                value={searchText}
                onInput={(e) => {
                  setSearchText(e.target.value);
                  searchCandidates(e.target.value);
                }}
                style={{ paddingRight: "2rem" }}
              />
              <i
                className="pi pi-search"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "49%",
                  transform: "translateY(-50%)",
                }}
              ></i>
            </div>
          </Col>
        </Row>
        <DataTable
          value={searchText ? searchResults : candidates}
          paginator
          lazy
          selection={selectedJobs}
          onSelectionChange={(e) => setSelectedJobs(e.value)}
          dataKey="candidate_id"
          rowsPerPageOptions={[5, 10, 25]}
          size="small"
          first={lazyParamsCand.first}
          rows={lazyParamsCand.rows}
          totalRecords={records}
          onPage={onPageChange}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
        >
          <Column selectionMode="multiple" style={{ width: "3em" }} />
          <Column header="Candidate Name" body={(rowData) => `${rowData.first_name || ''} ${rowData.middle_name || ''} ${rowData.last_name || ''}`} />
          <Column field="job_title" header="Designation" />
          <Column field="current_company" header="Company" />
        </DataTable>
        {selectedJobs.length > 0 && (
          <div className="d-flex mt-3">
            <button
              type="button"
              className="btn btn-primary me-2 btn-main"
              onClick={handleSave}
            >
              Ok
            </button>
            <button
              type="button"
              className="btn btn-primary btn-main"
              onClick={handleRefresh}
            >
              Refresh
            </button>
          </div>
        )}
      </Dialog>
      <Dialog
        header="Select Contact"
        visible={linkContactsVisible}
        onHide={() => { setSearchTextTo(""); setLinkContactsVisible(false) }}
        style={{ width: "40vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        className="cand-details"
      >
        <Row>
          <Col lg={12}>
            <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
              <InputText
                placeholder="Search Contact"
                value={searchTextTo}
                onChange={handleSearchTo}
                style={{ paddingRight: "2rem" }}
              />
              <i
                className="pi pi-search"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "49%",
                  transform: "translateY(-50%)",
                }}
              ></i>
            </div>
          </Col>
        </Row>
        <DataTable
          value={filteredContacts(typeInterviewcontact, searchTextTo)}
          paginator
          lazy
          first={lazyParams.first}
          rows={lazyParams.rows}
          totalRecords={totalRecords}
          onPage={onPageChange1}
          selection={selectedContacts}
          onSelectionChange={(e) => setSelectedContacts(e.value || [])}
          dataKey="id"
          rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
        >
          <Column selectionMode="multiple" style={{ width: "3em" }} />
          <Column
            header="Contact Name"
            body={(rowData) => `${rowData.first_name || ''} ${rowData.middle_name || ''} ${rowData.last_name || ''}`}
          />
          <Column field="job_title" header="Designation" />
          <Column field="email" header="Email" />
        </DataTable>
        <div className="d-flex mt-3">
          <button
            type="button"
            className="btn btn-primary me-2 btn-main"
            onClick={() => {
              handleSaveContact();
              setSearchTextTo("");
            }}
          >
            Ok
          </button>
          <button
            type="button"
            className="btn btn-primary btn-main"
            onClick={handleRefresh1}
          >
            Refresh
          </button>
        </div>
      </Dialog>
      <Dialog
        header="Select Contact"
        visible={linkContactsVisible1}
        onHide={() => {
          setSearchTextCc("");
          setLinkContactsVisible1(false);
        }}
        style={{ width: "40vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        className="cand-details"
      >
        <Row>
          <Col lg={12}>
            <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
              <InputText
                placeholder="Search Contact"
                value={searchTextCc}
                onChange={handleSearchCc}
                style={{ paddingRight: "2rem" }}
              />
              <i
                className="pi pi-search"
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "49%",
                  transform: "translateY(-50%)",
                }}
              ></i>
            </div>
          </Col>
        </Row>
        <DataTable
          value={typeInterviewcontact?.filter(contact =>
            contact?.first_name?.toLowerCase().includes(searchTextCc.toLowerCase()) ||
            contact?.job_title?.toLowerCase().includes(searchTextCc.toLowerCase()) ||
            contact?.email?.toLowerCase().includes(searchTextCc.toLowerCase())
          ) || []}
          paginator
          lazy
          first={lazyParams.first}
          rows={lazyParams.rows}
          totalRecords={totalRecords}
          onPage={onPageChange1}
          selection={selectedContacts1}
          onSelectionChange={(e) => setSelectedContacts1(e.value || [])}
          dataKey="id"
          rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          size="small"
        >
          <Column selectionMode="multiple" style={{ width: "3em" }} />
          <Column
            header="Contact Name"
            body={(rowData) => `${rowData.first_name || ''} ${rowData.middle_name || ''} ${rowData.last_name || ''}`}
          />
          <Column field="job_title" header="Designation" />
          <Column field="email" header="Email" />
        </DataTable>
        <div className="d-flex mt-3">
          <button
            type="button"
            className="btn btn-primary me-2 btn-main"
            onClick={() => {
              handleSaveContact1();
              setSearchTextCc("");
            }}
          >
            Ok
          </button>
          <button
            type="button"
            className="btn btn-primary btn-main"
            onClick={handleRefresh2}
          >
            Refresh
          </button>
        </div>
      </Dialog>
            <Dialog
        header="No Subject"
        visible={showNoSubjectConfirm}
        style={{ width: "400px" }}
        modal
        onHide={handleCancelSend}
        footer={
          <div>
            <Button label="Yes, Send" className="btn btn-primary me-2" onClick={handleConfirmSend} />
            <Button label="Cancel" className="btn btn-secondary" onClick={handleCancelSend} />
          </div>
        }
      >
        <p>Do you want to send this email without a subject?</p>
      </Dialog>
    </React.Fragment>
  );
};

export default SubmitContacttoCandidate;
